export default function Label({title,labelClass}){
    return <label className={labelClass}>{title}</label>
}